// @ts-nocheck
import { CloseButtonModal } from "components/CloseButton";
import { useClickOutside } from "hooks";
import React from "react";
import styled from "styled-components";

const Background = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(34, 34, 34, 0.5);
  z-index: 1010;
`;

const Container = styled.div`
  width: 588px;
  background-color: #ffffff;
  position: relative;
  padding: 90px 92px;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 600px) {
    width: 100vw;
    padding: 50px 52px;
  }
`;

const Title = styled.h1`
  font-family: Noah;
  font-style: normal;
  font-weight: 500;
  font-size: 46px;
  line-height: 56px;
  margin: 0;
  text-align: center;
  @media (max-width: 800px) {
    font-size: 30px;
  }
  @media (max-width: 500px) {
    font-size: 24px;
  }
`;

const SubTitle = styled.h2`
  font-family: Gilroy;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 120%;
  margin-top: 20px;
  text-align: center;
  @media (max-width: 800px) {
    font-size: 20px;
  }
  @media (max-width: 500px) {
    font-size: 16px;
  }
`;


export default function EmailIsBusy({ setIsEmailBusy }) {
  const handleClose = () => setIsEmailBusy(false);
  const modalRef = useClickOutside(handleClose);
  return (
    <Background>
      <Container ref={modalRef}>
        <CloseButtonModal
          onClick={handleClose}
        />
        <Title>Почта уже занята</Title>
        <SubTitle>Введите другую почту</SubTitle>
      </Container>
    </Background>
  );
}
